import { useQuery } from '@apollo/client';
import { ContactPageOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { Widget, WidgetContent, WidgetHeader, WidgetIcon, useScrollIntoView } from '@procureai/ui-mui';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { useModuleContext } from '~/components/ModuleContextProvider';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';
import { RiskCategoryIcon } from '~/components/RiskCategoryIcon/RiskCategoryIcon';

import { SUPPLIER_RISK_CATEGORY_SCORE_WIDGET_QUERY } from './SupplierRiskCategoryScoreWidget.gql';

const WIDGET_NAME = 'SupplierRiskCategoryScoreWidget';

export const SupplierRiskCategoryScoreWidget = () => {
  const { entityId } = useModuleContext();
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: WIDGET_NAME });
  const [widgetRef, active] = useScrollIntoView({ hash: 'supplier-risk-category-score' });
  const { data, loading } = useQuery(SUPPLIER_RISK_CATEGORY_SCORE_WIDGET_QUERY, { variables: { id: entityId } });

  const categories = data?.cataclysm?.supplier?.categories ?? [];
  return (
    <Widget ref={widgetRef} active={active} data-intercom-target={WIDGET_NAME}>
      <WidgetHeader title={t('title')} icon={<WidgetIcon icon={<ContactPageOutlined fontSize="small" />} />} />
      <WidgetContent>
        {!isEmpty(categories) ? (
          <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
            {categories.map((category) => {
              return (
                <Box key={category.id} sx={{ width: '400px', display: 'flex', margin: '8pt' }}>
                  <Box sx={{ alignContent: 'center' }}>
                    <RiskCategoryIcon id={category.id} score={category.score} fontSize="large" />
                  </Box>
                  <Box sx={{ marginLeft: '16pt' }}>
                    <Typography variant="h6">{category.name}</Typography>
                    <Typography variant="subtitle2">{t(`Score.${category.score}`)}</Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        ) : loading ? (
          <CircularProgressCentered sx={{ position: 'relative' }} />
        ) : (
          <PlaceholderWidget />
        )}
      </WidgetContent>
    </Widget>
  );
};
